import { useEffect } from 'react'
import { fetchContentTagOffers } from 'actions/ExperienceActions'
import { EmptyArray } from 'lib/array/arrayUtils'
import { getContentTagOffersKey } from 'lib/experiences/experienceUtils'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'

interface UseContentTagOffersResult {
  offerIds: Array<string>
  fetching: boolean
  error?: string
}

function useContentTagOffers(destinationId?: string, tagId?: string): UseContentTagOffersResult {
  const dispatch = useAppDispatch()
  const key = destinationId && tagId ? getContentTagOffersKey(destinationId, tagId) : undefined
  const result = useAppSelector(state => key ? state.experience.contentTagOffers[key] : undefined)

  useEffect(() => {
    if (destinationId && tagId) {
      dispatch(fetchContentTagOffers(destinationId, tagId))
    }
  }, [destinationId, tagId, dispatch])

  return {
    offerIds: result?.offerIds ?? EmptyArray,
    fetching: !!key && (result?.fetching ?? !result),
    error: result?.error,
  }
}

export default useContentTagOffers
